import type { Category } from "@/constants/categories";

type SnackProduct = {
  id: string;
  name: string;
  categorySlug: Category["slug"];
  brand: string;
  price: number;
  unit: string;
  image: string;
};

const IMG = {
  snacks: "https://images.unsplash.com/photo-1599490659213-4d0c089d562e?crop=entropy&cs=srgb&fm=jpg&q=85",
};

const item = (
  id: string,
  name: string,
  brand: string,
  unit: string,
  price: number,
): SnackProduct => ({
  id,
  name,
  categorySlug: "snacks",
  brand,
  unit,
  price,
  image: IMG.snacks,
});

export const SNACK_PRODUCTS: SnackProduct[] = [
  // Page 1 items
  item("snk-anand-namkeen-bhel", "Anand Namkeen Bhel Chaat Masala Cookies", "Anand", "200g", 4.99),
  item("snk-cappuccino-wafers", "Cappuccino Wafer Cookies", "VG Select", "150g", 3.99),
  item("snk-digestive-veg-crackers", "Digestive Veg Crackers", "McVitie's", "200g", 4.49),
  item("snk-right-angle-cashew", "Right Angle Cashew Cookies", "Right Angle", "150g", 4.99),

  // Kkobuk Chip / Korean snacks
  item("snk-kkobuk-choco", "Kkobuk Chip Choco", "Orion", "80g", 3.49),
  item("snk-kkobuk-corn", "Kkobuk Chip Corn", "Orion", "80g", 3.49),
  item("snk-kkobuk-injeolmi", "Kkobuk Chip Injeolmi", "Orion", "80g", 3.49),

  // Cookies & biscuits
  item("snk-butter-cookies-tin", "Butter Cookies Tin", "Danish", "454g", 9.99),
  item("snk-oatmeal-raisin-cookies", "Oatmeal Raisin Cookies", "VG Select", "200g", 4.49),
  item("snk-cream-crackers", "Cream Crackers", "Jacob's", "200g", 3.99),
  item("snk-digestive-wheat-biscuit", "Digestive Wheat Biscuit", "McVitie's", "400g", 5.99),
  item("snk-marie-gold-biscuit", "Marie Gold Biscuit", "Britannia", "250g", 3.49),

  // Chocolate snacks
  item("snk-kit-kat-mini", "Kit Kat Mini", "Nestlé", "12 pcs", 6.99),
  item("snk-bourbon-biscuit", "Bourbon Chocolate Biscuit", "Britannia", "150g", 2.99),
  item("snk-choco-pie", "Choco Pie", "Lotte", "6 pcs", 5.49),
  item("snk-chocolate-wafer-rolls", "Chocolate Wafer Rolls", "Pirouline", "100g", 4.99),

  // Savoury snacks
  item("snk-lay-classic-salt", "Lay's Classic Salted", "Lay's", "150g", 3.99),
  item("snk-coffee-bites-toffee", "Coffee Bites Toffee", "Parle", "200g", 3.49),
  item("snk-cashew-nut-cookies", "Cashew Nut Cookies", "Unibic", "150g", 4.49),

  // Cream crackers / savoury
  item("snk-cream-sandwich-biscuit", "Cream Sandwich Biscuit", "Oreo", "150g", 3.99),
  item("snk-peanut-chikki", "Peanut Chikki", "Jabsons", "200g", 3.99),
  item("snk-multigrain-chips", "Multigrain Chips", "Kettle", "150g", 4.99),

  // Page 2 items (My Bizcuit range)
  item("snk-mybizcuit-choco-hazelnut", "My Bizcuit Chocolate Filling Hazelnut Cookies", "My Bizcuit", "100g", 4.49),
  item("snk-mybizcuit-klassiz-marie-choco", "My Bizcuit Klassiz Marie Choco", "My Bizcuit", "160g", 3.99),
  item("snk-mybizcuit-klassiz-marie-ori", "My Bizcuit Klassiz Marie Ori", "My Bizcuit", "160g", 3.99),
  item("snk-mybizcuit-mini-digestive-choco", "My Bizcuit Mini Digestive Chocolate Chips Biscuit", "My Bizcuit", "120g", 3.99),
  item("snk-mybizcuit-speculaas-wafer", "My Bizcuit Speculaas Wafer", "My Bizcuit", "130g", 3.49),
  item("snk-mybizcuit-zoofino-cheese", "My Bizcuit Zoofino Cheese", "My Bizcuit", "80g", 2.99),
  item("snk-mybizcuit-zoofino-milk", "My Bizcuit Zoofino Milk Biscuit", "My Bizcuit", "80g", 2.99),
  item("snk-mybizcuit-mini-digestive-wholemeal", "MyBizcuit Mini Digestive Wholemeal Biscuit", "My Bizcuit", "120g", 3.99),

  // My Wafer
  item("snk-my-wafer", "My Wafer", "My Bizcuit", "130g", 3.49),

  // Ritz
  item("snk-ritz-crackers", "Ritz Crackers", "Ritz", "200g", 4.99),

  // More from page 1
  item("snk-granola-bar-oats-honey", "Granola Bar Oats & Honey", "Nature Valley", "42g", 1.99),
  item("snk-protein-bar-choco", "Protein Bar Chocolate", "Kind", "40g", 2.99),
  item("snk-rice-crackers-seaweed", "Rice Crackers Seaweed", "Want Want", "150g", 3.49),
  item("snk-butter-toast-rusk", "Butter Toast Rusk", "Britannia", "200g", 3.49),
  item("snk-salted-cashews", "Salted Cashews", "VG Select", "200g", 7.99),
];
